// export enum QC_STATUS {
//   PASS = 'PASS',
//   FAIL = 'FAIL',
// }

export enum REPORT_STATUS {
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED',
  UNDER_SUPPORT = 'UNDER_SUPPORT',
  READY = 'READY',
  COMPLETED = 'COMPLETED',
  REPORT_ERROR = 'REPORT_ERROR',
  REPORT_READY = 'REPORT_READY',
  REPORT_UNDER_SUPPORT = 'REPORT_UNDER_SUPPORT',
}

export enum PDF_QC {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export enum ShotgunReportStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum ReportOrderField {
  REPORT_READY_DATE = 'reportReadyDate',
  SAMPLE_RECEIVED_DATE = 'sampleReceivedDate',
}

export enum ReportTabKey {
  SIXTEEN_S = '16s',
  ANALYSIS = 'analysis',
  FMT = 'fmt',
}
